<template>
  <div>
    <el-dialog
      class="adaptationModal"
      v-el-drag-dialog
      :visible.sync="dialogVisible"
      :close-on-click-modal="false"
      :title="disabled ? '详情' : rtRouteMaterialVo.pkid ? '编辑' : '新建'"
      width="1100px"
      @close="$reset('form')"
    >
      <el-form
        :disabled="disabled"
        v-loading="contentLoading"
        ref="form"
        :model="rtRouteMaterialVo"
        :rules="ruleValidate"
        class="form"
        label-width="80px"
      >
        <div class="editTitle">基本信息</div>
        <el-row>
          <el-col :span="12" v-if="rtRouteMaterialVo.pkid">
            <el-form-item label="工艺编号">
              <el-input v-model="rtRouteMaterialVo.routeMaterialNo" disabled />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="物料名称" prop="materialName">
              <el-input v-model="rtRouteMaterialVo.materialName" placeholder="请选择物料" readonly>
                <el-button slot="append" @click="$refs.selectMaterial.open(10)" icon="el-icon-search"></el-button>
              </el-input>
              <material-select ref="selectMaterial" @select="selectMaterial" />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="工艺路线" prop="routingName">
              <el-input
                :disabled="!rtRouteMaterialVo.materialName"
                v-model="rtRouteMaterialVo.routingName"
                placeholder="请选择工艺路线"
                readonly
              >
                <el-button
                  :disabled="!rtRouteMaterialVo.materialName"
                  slot="append"
                  @click="$refs.selectRtRoute.open()"
                  icon="el-icon-search"
                ></el-button>
              </el-input>
              <rt-route-select ref="selectRtRoute" @select="selectRtRoute" />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="工艺状态" prop="status">
              <el-select v-model="rtRouteMaterialVo.status" placeholder="请选择工艺状态">
                <el-option label="待确认" :value="10" />
                <el-option label="已确认" :value="20" />
                <el-option label="已作废" :value="90" />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="备注">
              <el-input autosize v-model="rtRouteMaterialVo.note" type="textarea" placeholder="请输入" />
            </el-form-item>
          </el-col>
        </el-row>
        <div class="editTitle">工艺信息</div>
        <el-button
          type="primary"
          :disabled="!rtRouteMaterialVo.materialName || !rtRouteMaterialVo.routingName || disabled"
          style="margin-bottom: 8px"
          @click="childDialogOne = true"
        >
          添加
        </el-button>
        <div style="display: flex">
          <div class="tree">
            <el-tree
              ref="tree"
              :data="treeData"
              node-key="key"
              :props="treeProps"
              highlight-current
              default-expand-all
              :expand-on-click-node="false"
              @current-change="currentChange"
            />
          </div>
          <div class="treeContent">
            <Table :draggable="!disabled" @on-drag-drop="tableDrag" border stripe :columns="columns" :data="tableData">
              <template slot="action" slot-scope="{ row, index }">
                <el-button type="danger" :disabled="row.isMainSn || disabled" @click="deleteHandle(row, index)">删除</el-button>
              </template>
              <template v-if="row.scanIndex === 1" slot="esopSlot" slot-scope="{ row, index }">
                <el-input v-model="row.esopName" placeholder="请选择ESOP文件" readonly>
                  <el-button id="fileButton" slot="append" @click="$refs.esopSelect.open()" icon="el-icon-search"></el-button>
                </el-input>
              </template>
            </Table>
          </div>
        </div>
      </el-form>
      <span slot="footer">
        <el-button @click="dialogVisible = false">取消</el-button>
        <el-button v-if="!disabled" :loading="submitLoading" type="primary" @click="submitHandle">确定</el-button>
      </span>
    </el-dialog>

    <!-- 添加工艺信息 -->
    <el-dialog
      v-el-drag-dialog
      :visible.sync="childDialogOne"
      :close-on-click-modal="false"
      title="新建"
      width="600px"
      @close="childDialogOneClose"
    >
      <el-form ref="formChild" :model="model" :rules="childOneRuleValidate" class="form" label-width="90px">
        <el-form-item label="部件名称" prop="partsName">
          <el-input v-model="model.partsName" placeholder="请选择部件" readonly>
            <el-button slot="append" @click="$refs.selectParts.open()" icon="el-icon-search"></el-button>
          </el-input>
          <material-select ref="selectParts" @select="selectParts" />
        </el-form-item>
        <el-form-item label="固定工时" prop="fixedWorkingTime">
          <el-input v-model="model.fixedWorkingTime" placeholder="请输入固定工时" />
        </el-form-item>
        <el-form-item label="变动工时" prop="variableWorkingTime">
          <el-input v-model="model.variableWorkingTime" placeholder="请输入变动工时" />
        </el-form-item>
        <el-form-item label="是否唯一码" prop="isUniqueSn">
          <el-select v-model="model.isUniqueSn" clearable placeholder="请选择是否唯一码">
            <el-option label="唯一码" :value="true" />
            <el-option label="自制条码" :value="false" />
          </el-select>
        </el-form-item>
      </el-form>
      <span slot="footer">
        <el-button @click="childDialogOne = false">取消</el-button>
        <el-button type="primary" @click="addParts">确定</el-button>
      </span>
    </el-dialog>

    <EsopSelect ref="esopSelect" @select="esopSelect"></EsopSelect>
  </div>
</template>

<script>
import MaterialSelect from "@/views/information/Material/MaterialSelect";
import RtRouteSelect from "@/views/information/RtRoute/RtRouteSelect";
import EsopSelect from "@/views/information/Esop/EsopSelect";
export default {
  components: {
    MaterialSelect,
    RtRouteSelect,
    EsopSelect,
  },
  data() {
    return {
      disabled: false,
      // 工艺信息模态框
      childDialogOne: false,
      model: {
        partsName: "",
        partsNo: "",
        fixedWorkingTime: "",
        variableWorkingTime: "",
        isUniqueSn: "",
      },
      childOneRuleValidate: {
        partsName: { required: true, message: "请选择物料", trigger: "change" },
        fixedWorkingTime: { required: true, message: "请输入固定工时", trigger: "blur" },
        variableWorkingTime: { required: true, message: "请输入变动工时", trigger: "blur" },
        isUniqueSn: { required: true, message: "请选择是否唯一码", trigger: "change" },
      },
      // 树形菜单
      treeData: [],
      treeProps: {
        label: "title",
      },
      columns: [
        {
          type: "index",
          width: 50,
          align: "center",
        },
        {
          title: "部件编号",
          key: "partsNo",
          width: 160,
        },
        {
          title: "部件名称",
          key: "partsName",
          minWidth: 360,
          tooltip: true,
        },
        {
          title: "ESOP文件",
          key: "esopName",
          minWidth: 280,
          tooltip: true,
          slot: "esopSlot",
        },
        {
          title: "页码",
          key: "esopPageNo",
          width: 70,
          align: "center",
        },
        {
          title: "主条码",
          key: "isMainSn",
          width: 80,
          align: "center",
          render: (h, params) => {
            return h("span", params.row.isMainSn ? "是" : "否");
          },
        },
        {
          title: "唯一码",
          key: "isUniqueSn",
          width: 80,
          align: "center",
          render: (h, params) => {
            return h("span", params.row.isUniqueSn ? "是" : "否");
          },
        },
        {
          title: "固定工时",
          key: "fixedWorkingTime",
          width: 90,
          align: "center",
        },
        {
          title: "变动工时",
          key: "variableWorkingTime",
          width: 90,
          align: "center",
        },
        {
          title: "操作",
          align: "center",
          width: 80,
          slot: "action",
          fixed: "right",
        },
      ],
      tableData: [],
      currentTree: {},
      // 产品工艺新建
      dialogVisible: false,
      submitLoading: false,
      contentLoading: false,
      rtRouteMaterialVo: {
        materialName: "",
        materialId: "",
        materialNo: "",
        routingName: "",
        routingId: "",
        routeNo: "",
        status: "",
        note: "",
        recoilMaterialList: [],
        routeProcessMaterialList: [],
      },
      ruleValidate: {
        materialName: { required: true, message: "请选择物料", trigger: "change" },
        routingName: { required: true, message: "请选择工艺路线", trigger: "change" },
        status: { required: true, message: "请选择工艺状态", trigger: "change" },
      },
    };
  },

  methods: {
    open(row, mark) {
      this.disabled = mark;
      this.dialogVisible = true;
      if (row) {
        this.getData(row.pkid);
      }
    },

    selectMaterial(row) {
      this.rtRouteMaterialVo.materialName = row.materialName;
      this.rtRouteMaterialVo.materialId = row.materialID;
      this.rtRouteMaterialVo.materialNo = row.materialNO;
    },

    selectRtRoute(row) {
      this.rtRouteMaterialVo.routingId = row.pkid;
      this.rtRouteMaterialVo.routeNo = row.routeNo;
      this.rtRouteMaterialVo.routingName = row.routingName;
      this.getTree();
    },

    // 根据物料id、工艺路线id查询工艺信息
    getTree() {
      this.$http
        .get(
          "basic",
          `rtRouteMaterials/processTree?materialId=${this.rtRouteMaterialVo.materialId}&routeId=${this.rtRouteMaterialVo.routingId}`
        )
        .then((resp) => {
          if (resp.success) {
            this.treeData = resp.data.treeData;
            this.rtRouteMaterialVo.routeProcessMaterialList = resp.data.details;
            if (this.treeData.length) {
              this.$nextTick(() => {
                this.$refs.tree.setCurrentKey(this.treeData[0].key);
                this.tableData = this.rtRouteMaterialVo.routeProcessMaterialList.filter((item) => item.processIndex === 1);
                this.currentTree = this.treeData[0];
              });
            }
          }
        });
    },

    // 新增工艺部件
    addParts() {
      this.$refs.formChild.validate((valid) => {
        if (valid) {
          var newArr = this.tableData.slice().sort(function (a, b) {
            return b.scanIndex - a.scanIndex;
          });
          const obj = {
            scanIndex: newArr[0].scanIndex + 1,
            isMainSn: false,
            processNo: this.currentTree.processNo,
            processId: this.currentTree.processId,
            processName: this.currentTree.title,
            processIndex: this.currentTree.processIndex,
            ...this.model,
          };
          this.tableData.push(obj);
          this.rtRouteMaterialVo.routeProcessMaterialList.push(obj);
          this.childDialogOne = false;
        }
      });
    },

    selectParts(row) {
      this.model.partsName = row.materialName;
      this.model.partsNo = row.materialNO;
    },

    currentChange(node) {
      if (node.hasOwnProperty("children")) {
        this.currentTree = node;
        this.tableData = this.rtRouteMaterialVo.routeProcessMaterialList.filter((item) => item.processIndex === node.processIndex);
      }
    },

    deleteHandle(row, index) {
      this.tableData.splice(index, 1);
      let newArr = [];
      this.rtRouteMaterialVo.routeProcessMaterialList.forEach((item) => {
        if (item.scanIndex !== row.scanIndex || item.processIndex !== row.processIndex) {
          newArr.push(item);
        }
      });
      this.rtRouteMaterialVo.routeProcessMaterialList = newArr;
    },

    esopSelect(row) {
      this.tableData[0].esopName = row.esopName;
      this.rtRouteMaterialVo.routeProcessMaterialList.forEach((item) => {
        if (item.processIndex === this.currentTree.processIndex) {
          item.esopId = row.pkId;
          item.esopNo = row.esopNo;
          item.esopFile = row.filePath;
        }
      });
    },

    // 根据产品工艺id获取详细信息
    getData(pkid) {
      this.contentLoading = true;
      this.$http
        .get("basic", `rtRouteMaterials/${pkid}`)
        .then((res) => {
          if (res.success) {
            this.rtRouteMaterialVo = Object.assign(this.rtRouteMaterialVo, res.data);
            this.treeData = res.data.routeMaterialTree.treeData;
            this.rtRouteMaterialVo.routeProcessMaterialList = JSON.parse(JSON.stringify(res.data.routeMaterialTree.details));
            if (this.treeData.length) {
              this.$nextTick(() => {
                this.$refs.tree.setCurrentKey(this.treeData[0].key);
                this.currentTree = this.treeData[0];
                this.tableData = this.rtRouteMaterialVo.routeProcessMaterialList.filter((item) => item.processIndex === 1);
              });
            }
          }
          this.contentLoading = false;
        })
        .catch(() => {
          this.contentLoading = false;
        });
    },

    submitHandle() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          this.submitLoading = true;
          this.$http
            .save("basic", "rtRouteMaterials", this.rtRouteMaterialVo)
            .then((resp) => {
              this.submitLoading = false;
              if (resp.success) {
                this.dialogVisible = false;
                if (this.rtRouteMaterialVo.pkid) {
                  this.$emit("save-success");
                  this.$message.success("编辑成功");
                } else {
                  this.$emit("save-success");
                  this.$message.success("添加成功");
                }
              } else {
                this.dialogVisible = false;
              }
            })
            .catch(() => {
              this.submitLoading = false;
            });
        }
      });
    },

    tableDrag(index1, index2) {
      if (index1 != 0 && index2 != 0) {
        const temp = this.tableData[index1].scanIndex;
        this.tableData[index1].scanIndex = this.tableData[index2].scanIndex;
        this.tableData[index2].scanIndex = temp;
        this.tableData[index1] = this.tableData.splice(index2, 1, this.tableData[index1])[0];
        const newArr = this.rtRouteMaterialVo.routeProcessMaterialList.filter(
          (item) => item.processIndex !== this.currentTree.processIndex
        );
        this.rtRouteMaterialVo.routeProcessMaterialList = newArr.concat(this.tableData);
      } else {
        this.$message.warning("禁止改变主条码顺序");
      }
    },

    childDialogOneClose() {
      this.childDialogOne = false;
      this.$refs.formChild.resetFields();
    },
  },
};
</script>

<style lang="scss" scoped>
.tree {
  flex: 1;
  border: 1px solid #ddd;
  margin-right: 5px;
  padding: 5px;
}
.treeContent {
  width: 870px;
}
</style>
<style>
#fileButton {
  padding: 7px 15px !important;
}
</style>
